"use client";

import { BSRUpload } from "./bsr/BSRUpload";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Upload as LegacyUpload } from "./legacy/Upload";

export const Upload = createBSRExperimentIcon(LegacyUpload, BSRUpload);
